import { useGetAppConfig } from './useGetAppConfig';
import {
  Box,
  Switch,
  Tooltip,
  IconButton,
  Typography,
} from '@mui/material';
import { Semaphore } from './Semaphore';
import LockIcon from '@mui/icons-material/Lock';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export const NotePreferences = () => {
  const {
    remoteAppConfig: { notePreferences },
  } = useGetAppConfig();

  return (
    <Box marginTop="2rem">
      <Box
        display="flex"
        alignItems="center"
        gap={0.5}
        marginBottom={1}
      >
        <Typography variant="h6">Note Preferences</Typography>
        <Tooltip title="This feature is stable and permanently enabled. The flag will be removed in a future update.">
          <IconButton size="small" sx={{ padding: 0.5 }}>
            <HelpOutlineIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        gap={1}
      >
        <Box display="flex" alignItems="center" gap={0.5}>
          <LockIcon
            sx={{ fontSize: '1rem', color: 'text.secondary' }}
          />
          <Switch
            checked={notePreferences?.enabled ?? false}
            disabled={true}
          />
        </Box>
        <Box
          marginLeft="1rem"
          display="flex"
          flexDirection="row"
          alignItems="center"
        >
          <Semaphore enabled={notePreferences?.enabled ?? false} />
        </Box>
      </Box>
    </Box>
  );
};
